import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';
import { formatViews } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`蘑菇成品人视频 - ${video.title}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-900/75 text-background-50 text-xs px-2 py-0.5 rounded-md">
          <i className="ri-play-circle-line mr-1"></i>
          {video.duration}
        </div>
        {video.featured && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            精选
          </div>
        )}
        <div className="absolute inset-0 bg-foreground-900/0 group-hover:bg-foreground-900/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">
          {video.description}
        </p>
        <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
          <span>{video.date}</span>
        </div>
      </div>
    </Link>
  );
}